// Login.js
import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import styles from "./styles.module.css";
import logo from '../assets/logo.png';
import { useDispatch } from 'react-redux';
import { login } from '../redux/authSlice';
import { setUser } from '../state/index'
// import {useRegisterUserMutation} from "../state/api"
import { signInWithEmailAndPassword, signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { auth } from '../firebase';
import { Google } from '@mui/icons-material';

const Login = () => {
	const [data, setData] = useState({ email: "", password: "" });
	const [error, setError] = useState("");
	const navigate = useNavigate();
	// const [saveGoogleUser] = useRegisterUserMutation();
	const handleChange = ({ currentTarget: input }) => {
		setData({ ...data, [input.name]: input.value });
	};
	const [verificationError, setVerificationError] = useState('');

	const dispatch = useDispatch();

	const handleEmailPasswordLogin = async (email, password) => {
    try {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
    	const user = userCredential.user;

		if (!user.emailVerified) {
			setVerificationError('Please verify your email before logging in.');
			return;
		}

		dispatch(login({ user: user }));
		dispatch(setUser(user))
		localStorage.setItem('user', JSON.stringify(user));
		navigate('/dashboard');
    } catch (error) {
        setError(error.message);
    }
	};

	const fetchUserRole = async () => {
		try {
			const user = JSON.parse(localStorage.getItem('user'));
			console.log("user.email", user.email);

			const baseUrl = process.env.REACT_APP_BASE_URL;
			const response = await fetch(`${baseUrl}/general/user/${encodeURIComponent(user.email)}`);

			if (!response.ok) {
				console.error(`User role fetch failed: ${response.status} - ${response.statusText}`);
				return;
			}

			const data = await response.json();
			if (data && data.role) {
				const updatedUser = { ...user, role: data.role };
				localStorage.setItem('user', JSON.stringify(updatedUser));
				dispatch(setUser(updatedUser));
				console.log("USER ROLE:", data.role);
			}
		} catch (error) {
			console.error('Error fetching user role:', error);
		}
	};
	

	const handleGoogleSignIn = async () => {
		const provider = new GoogleAuthProvider();
		provider.addScope('https://www.googleapis.com/auth/documents');
		provider.addScope('https://www.googleapis.com/auth/drive');
		provider.addScope('email');
		provider.addScope('https://www.googleapis.com/auth/calendar');
    try {
		const result = await signInWithPopup(auth, provider);
		const accessToken = result._tokenResponse.oauthAccessToken;
        const userData = {
            email: result._tokenResponse.email,
            displayName: result.user.displayName,
			photoURL: result.user.photoURL,
			lastLoginAt: result.user.metadata.lastLoginAt,
			accessToken: accessToken,
		};
		const saveUserData = {
			email: result._tokenResponse.email,
			name: result.user.displayName,
			lastLoginAt: result.user.metadata.lastLoginAt,
			profilePic: result.user.photoURL,
			isSocialLogin: true,
		};

		dispatch(login({ user: userData }));
		dispatch(setUser(userData));
		// saveGoogleUser(saveUserData);
		localStorage.setItem('user', JSON.stringify(userData));
		await fetchUserRole();
		navigate('/dashboard');
    } catch (error) {
        setError(error.message);
    }
};
		
	const handleSubmit = async (e) => {
		e.preventDefault();
		await handleEmailPasswordLogin(data.email, data.password);
	};

	return (
		<div className={styles.login_container}>
			
			<div className={styles.login_form_container}>
				<form className={styles.form_container} onSubmit={handleSubmit}>
					<div className={styles.logo_container}>
						<img src={logo} alt="Logo" className={styles.logo} />
					</div>
					<h1>Login</h1>
					<input
						type="email"
						placeholder="Email"
						name="email"
						onChange={handleChange}
						value={data.email}
						required
						className={styles.input}
					/>
					<input
						type="password"
						placeholder="Password"
						name="password"
						onChange={handleChange}
						value={data.password}
						required
						className={styles.input}
					/>
					{error && <div className={styles.error_msg}>{error}</div>}
					{verificationError && (
						<div className="error">
						{verificationError}
						</div>
					)}
					<div className={styles.button_container}>
						<button type="submit" className={styles.green_btn}>
							Sign In
						</button>
						<button className={styles.google_btn} onClick={handleGoogleSignIn}>
							<Google fontSize='' /> Login with Google
						</button>
					</div>
				</form>
			</div>
		</div>
	);
};

export default Login;